<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<m-search-item label="部门编号">
					<c-input name="department_code"></c-input>
				</m-search-item>
				<m-search-item label="部门名称">
					<c-input name="department_name"></c-input>
				</m-search-item>
			</m-search>

			<m-operate :batch="batchData.length" @batchCancel="batchCancel">
				<c-button color="main" v-if="auth('b_department_edit')" v-lock="lock('b_department_edit')" prepend-icon="tf-add" @click="$refs.departmentEdit.open()">创建部门</c-button>
				
				<template #batch>
					<c-button v-if="auth('b_department_edit')" v-lock="lock('b_department_edit')" prepend-icon="tf-trash" color="red" :hollow="true" @click="batchRemoveDepartment">删除</c-button>
				</template>
			</m-operate>

			<c-table ref="list" height="grow">
				<c-table-column
					type="selector"
					width="32"
					@handle="batchSelect"
				></c-table-column>
				
				<c-table-column
					label="部门编号"
					name="department_code"
					width="100"
				>
				</c-table-column>

				<c-table-column
					label="部门名称"
					name="department_name"
					width="100"
				>
				</c-table-column>

				<c-table-column
					label="用户姓名"
					name="user_names"
					width="200"
				>
					<template #default="{data}">
						<span v-if="!data.user_names">-</span>
						<c-tags v-else :value="data.user_names"></c-tags>
					</template>
				</c-table-column>

				<c-table-column
					label="创建人"
					name="create_user_realname"
				>
					<template #default="{data}">
						<span v-if="data.is_manage == 1">-</span>
						<span v-else>{{data.create_user_realname}}</span>
					</template>
				</c-table-column>

				<c-table-column
					label="创建时间"
					name="create_date"
					width="140"
				></c-table-column>

				<c-table-column
					type="button"
					label="操作"
					width="110"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_department_edit')" v-lock="lock('b_department_edit')" icon="tf-edit" @click="$refs.departmentEdit.open(data)">编辑</c-table-button>
						<c-table-button v-if="auth('b_department_edit')" v-lock="lock('b_department_edit')" icon="tf-trash" color="red" @click="removeDepartment(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</c-table>
			<!--创建/编辑部门弹窗-->
			<department-edit ref="departmentEdit" @resolve="$refs.list.update()"></department-edit>
		</module>
	</page>
</template>

<script>
	import departmentEdit from "./department_edit.vue";
	import {batchData, batchMethods} from '@/components/public/batch.js'

	export default {
		components: {
			departmentEdit
		},

		data() {
			return {
				...batchData()
			}
		},

		mounted() {
			this.searchHandle();
		},

		methods: {
			...batchMethods(),
			
			/************搜索列表**************/
			searchHandle(data){
				if (!data){
					data = {};
				}
				this.$refs.list.load({
					url: '/department/list',
					data
				});
			},

			/****批量删除部门**/
			batchRemoveDepartment(){
				var ids = [];
				this.$refs.list.getData('selected').forEach(item => {
					ids.push(item.id);
				});
				
				this.$confirm({
					message:'确认删除' + ids.length + '个部门吗？删除后不可恢复',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/department/delete/batch',
							data: {ids: ids},
							loading: true,
							success: data => {
								let Mtype = 'success';
								let message = '成功' + data.success_count + '条';
								if(data.fail_count > 0 && data.success_count > 0){
									Mtype = 'warn';
									message += '，失败'+data.fail_count+'条';
								}else if(data.fail_count > 0 && data.success_count == 0){
									Mtype = 'fail'
									message += '，失败'+data.fail_count+'条';
								}else{
									message = '成功删除' + data.success_count + '条记录';
								}
								this.$message({
									message: message,  // 提示内容,
									type: Mtype
								});
								//刷新
								this.$refs.list.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

			/************删除部门**************/
			removeDepartment(data){
				this.$confirm({
					message:'确认删除部门【'+data.department_name+'】？删除后不可恢复',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/department/delete',
							data: {id:data.id},
							loading: true,
							success: data => {
								this.$message({
									message:'删除成功',  // 提示内容,
									type: 'success'
								});
								this.$refs.list.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},
		}
	}
</script>

<style lang="stylus" scoped>
</style>